define("settings/components/meta-ad-accounts-card/group-ad-accounts-tab/add-modal/index", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "tracked-built-ins", "later/utils/meta-ad-account-status", "later/utils/to-array", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _trackedBuiltIns, _metaAdAccountStatus, _toArray, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"tracked-built-ins",0,"later/utils/meta-ad-account-status",0,"later/utils/to-array",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck }}
  <Shared::Modal @close={{@onClose}} @closeButtonQaClass="qa--mmaAddModal__dismissBtn" as |modal|>
    <modal.card @portrait={{true}} class="tAC--mmaAddModal qa--mmaAddModal">
      <modal.card-header class="tAC--mmaAddModal__header">
        <p class="o--modalHeader__title tAC--mmaAddModal__title qa--mmaAddModal__title">
          {{t "account.groups.group.meta_ad_accounts.add_modal.title" groupName=@group.name}}
        </p>
      </modal.card-header>
      <modal.card-body>
        {{#if this.bannerError}}
          <div class="tAC--mmaAddModal__banner qa--mmaAddModal__banner">{{this.bannerError}}</div>
        {{/if}}
  
        {{#if this.availableAccounts.length}}
          <ul class="tAC--mmaAddModal__list">
            {{#each this.availableAccounts as |adAccount|}}
              <li
                class="tAC--mmaAddModal__row qa--mmaAddModal__row
                  {{if (this.isSelected adAccount.id) 'tAC--mmaAddModal__row--selected'}}"
                data-ad-account-id={{adAccount.id}}
                role="button"
                {{on "click" (fn this.toggleSelect adAccount.id)}}
              >
                <div class="tAC--mmaAddModal__rowCheck">
                  <span
                    class="tAC--mmaAddModal__checkIcon qa--mmaAddModal__checkIcon
                      {{if (this.isSelected adAccount.id) 'tAC--mmaAddModal__checkIcon--on'}}"
                  >
                    {{#if (this.isSelected adAccount.id)}}
                      {{svg-jar "check" class="tAC--mmaAddModal__checkGlyph"}}
                    {{/if}}
                  </span>
                </div>
                <div class="tAC--mmaAddModal__rowBody">
                  <div class="tAC--mmaAddModal__rowNameRow">
                    <span class="tAC--mmaAddModal__rowName qa--mmaAddModal__rowName">{{adAccount.name}}</span>
                    {{#let (this.statusBadgeFor adAccount) as |badge|}}
                      {{#if badge}}
                        <span
                          class="tAC--mmaAddModal__statusBadge tAC--mmaAddModal__statusBadge--{{badge.kind}}
                            qa--mmaAddModal__statusBadge"
                          data-badge-name={{badge.name}}
                        >
                          {{t (concat "account.meta_marketing_api.assignments_modal.status_badge." badge.name)}}
                        </span>
                      {{/if}}
                    {{/let}}
                  </div>
                  <div class="tAC--mmaAddModal__rowSubtitle qa--mmaAddModal__rowSubtitle">
                    {{#if adAccount.businessPortfolioName}}
                      {{t
                        "account.meta_marketing_api.assignments_modal.row.subtitle_with_portfolio"
                        businessPortfolioName=adAccount.businessPortfolioName
                        uid=adAccount.uid
                      }}
                    {{else}}
                      {{t "account.meta_marketing_api.assignments_modal.row.subtitle_id_only" uid=adAccount.uid}}
                    {{/if}}
                  </div>
                  {{#let (this.statusBadgeFor adAccount) as |badge|}}
                    {{#if badge.hasWarning}}
                      <div class="tAC--mmaAddModal__statusWarning qa--mmaAddModal__statusWarning">
                        {{t "account.groups.group.meta_ad_accounts.add_modal.status_warning_generic"}}
                      </div>
                    {{/if}}
                  {{/let}}
                </div>
              </li>
            {{/each}}
          </ul>
        {{else}}
          <p class="tAC--mmaAddModal__availableEmpty qa--mmaAddModal__availableEmpty">
            {{t "account.groups.group.meta_ad_accounts.add_modal.available_empty"}}
          </p>
        {{/if}}
  
        <div class="tAC--mmaAddModal__drawer qa--mmaAddModal__drawer">
          <button
            aria-expanded={{this.drawerOpen}}
            class="tAC--mmaAddModal__drawerHeader qa--mmaAddModal__drawerHeader"
            type="button"
            {{on "click" this.toggleDrawer}}
          >
            <span class="tAC--mmaAddModal__drawerTitle">
              {{t "account.groups.group.meta_ad_accounts.add_modal.added_accounts_header"}}
            </span>
            {{#if this.drawerOpen}}
              {{svg-jar "caret-up" class="tAC--mmaAddModal__drawerCaret"}}
            {{else}}
              {{svg-jar "caret-down" class="tAC--mmaAddModal__drawerCaret"}}
            {{/if}}
          </button>
          {{#if this.drawerOpen}}
            <ul class="tAC--mmaAddModal__drawerBody qa--mmaAddModal__drawerBody">
              {{#each this.addedAccounts as |adAccount|}}
                <li
                  class="tAC--mmaAddModal__addedRow tAC--mmaAddModal__addedRow--dimmed qa--mmaAddModal__addedRow"
                  data-ad-account-id={{adAccount.id}}
                >
                  <div class="tAC--mmaAddModal__rowCheck">
                    <span class="tAC--mmaAddModal__checkIcon tAC--mmaAddModal__checkIcon--on">
                      {{svg-jar "check" class="tAC--mmaAddModal__checkGlyph"}}
                    </span>
                  </div>
                  <div class="tAC--mmaAddModal__rowBody">
                    <span class="tAC--mmaAddModal__rowName">{{adAccount.name}}</span>
                    <div class="tAC--mmaAddModal__rowSubtitle">
                      {{#if adAccount.businessPortfolioName}}
                        {{t
                          "account.meta_marketing_api.assignments_modal.row.subtitle_with_portfolio"
                          businessPortfolioName=adAccount.businessPortfolioName
                          uid=adAccount.uid
                        }}
                      {{else}}
                        {{t "account.meta_marketing_api.assignments_modal.row.subtitle_id_only" uid=adAccount.uid}}
                      {{/if}}
                    </div>
                  </div>
                </li>
              {{/each}}
            </ul>
          {{/if}}
        </div>
      </modal.card-body>
      <modal.card-footer class="tAC--mmaAddModal__footer">
        <Shared::Ui::Button
          @isDisabled={{this.cantSave}}
          @onClick={{this.save}}
          @text={{t "account.groups.group.meta_ad_accounts.add_modal.add_button" count=this.selectedCount}}
          @variant="primary"
          class="tAC--mmaAddModal__saveBtn qa--mmaAddModal__saveBtn"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "+TtpjWA3",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@closeButtonQaClass\"],[[30,1],\"qa--mmaAddModal__dismissBtn\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],[[24,0,\"tAC--mmaAddModal qa--mmaAddModal\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],[[24,0,\"tAC--mmaAddModal__header\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"o--modalHeader__title tAC--mmaAddModal__title qa--mmaAddModal__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.groups.group.meta_ad_accounts.add_modal.title\"],[[\"groupName\"],[[30,3,[\"name\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"bannerError\"]],[[[1,\"        \"],[10,0],[14,0,\"tAC--mmaAddModal__banner qa--mmaAddModal__banner\"],[12],[1,[30,0,[\"bannerError\"]]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"availableAccounts\",\"length\"]],[[[1,\"        \"],[10,\"ul\"],[14,0,\"tAC--mmaAddModal__list\"],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"availableAccounts\"]]],null]],null],null,[[[1,\"            \"],[11,\"li\"],[16,0,[29,[\"tAC--mmaAddModal__row qa--mmaAddModal__row\\n                \",[52,[28,[30,0,[\"isSelected\"]],[[30,4,[\"id\"]]],null],\"tAC--mmaAddModal__row--selected\"]]]],[16,\"data-ad-account-id\",[30,4,[\"id\"]]],[24,\"role\",\"button\"],[4,[38,5],[\"click\",[28,[37,6],[[30,0,[\"toggleSelect\"]],[30,4,[\"id\"]]],null]],null],[12],[1,\"\\n              \"],[10,0],[14,0,\"tAC--mmaAddModal__rowCheck\"],[12],[1,\"\\n                \"],[10,1],[15,0,[29,[\"tAC--mmaAddModal__checkIcon qa--mmaAddModal__checkIcon\\n                    \",[52,[28,[30,0,[\"isSelected\"]],[[30,4,[\"id\"]]],null],\"tAC--mmaAddModal__checkIcon--on\"]]]],[12],[1,\"\\n\"],[41,[28,[30,0,[\"isSelected\"]],[[30,4,[\"id\"]]],null],[[[1,\"                    \"],[1,[28,[35,7],[\"check\"],[[\"class\"],[\"tAC--mmaAddModal__checkGlyph\"]]]],[1,\"\\n\"]],[]],null],[1,\"                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,0],[14,0,\"tAC--mmaAddModal__rowBody\"],[12],[1,\"\\n                \"],[10,0],[14,0,\"tAC--mmaAddModal__rowNameRow\"],[12],[1,\"\\n                  \"],[10,1],[14,0,\"tAC--mmaAddModal__rowName qa--mmaAddModal__rowName\"],[12],[1,[30,4,[\"name\"]]],[13],[1,\"\\n\"],[44,[[28,[30,0,[\"statusBadgeFor\"]],[[30,4]],null]],[[[41,[30,5],[[[1,\"                      \"],[10,1],[15,0,[29,[\"tAC--mmaAddModal__statusBadge tAC--mmaAddModal__statusBadge--\",[30,5,[\"kind\"]],\"\\n                          qa--mmaAddModal__statusBadge\"]]],[15,\"data-badge-name\",[30,5,[\"name\"]]],[12],[1,\"\\n                        \"],[1,[28,[35,1],[[28,[37,9],[\"account.meta_marketing_api.assignments_modal.status_badge.\",[30,5,[\"name\"]]],null]],null]],[1,\"\\n                      \"],[13],[1,\"\\n\"]],[]],null]],[5]]],[1,\"                \"],[13],[1,\"\\n                \"],[10,0],[14,0,\"tAC--mmaAddModal__rowSubtitle qa--mmaAddModal__rowSubtitle\"],[12],[1,\"\\n\"],[41,[30,4,[\"businessPortfolioName\"]],[[[1,\"                    \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.row.subtitle_with_portfolio\"],[[\"businessPortfolioName\",\"uid\"],[[30,4,[\"businessPortfolioName\"]],[30,4,[\"uid\"]]]]]],[1,\"\\n\"]],[]],[[[1,\"                    \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.row.subtitle_id_only\"],[[\"uid\"],[[30,4,[\"uid\"]]]]]],[1,\"\\n\"]],[]]],[1,\"                \"],[13],[1,\"\\n\"],[44,[[28,[30,0,[\"statusBadgeFor\"]],[[30,4]],null]],[[[41,[30,6,[\"hasWarning\"]],[[[1,\"                    \"],[10,0],[14,0,\"tAC--mmaAddModal__statusWarning qa--mmaAddModal__statusWarning\"],[12],[1,\"\\n                      \"],[1,[28,[35,1],[\"account.groups.group.meta_ad_accounts.add_modal.status_warning_generic\"],null]],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]],null]],[6]]],[1,\"              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[4]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,2],[14,0,\"tAC--mmaAddModal__availableEmpty qa--mmaAddModal__availableEmpty\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.groups.group.meta_ad_accounts.add_modal.available_empty\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaAddModal__drawer qa--mmaAddModal__drawer\"],[12],[1,\"\\n        \"],[11,\"button\"],[16,\"aria-expanded\",[30,0,[\"drawerOpen\"]]],[24,0,\"tAC--mmaAddModal__drawerHeader qa--mmaAddModal__drawerHeader\"],[24,4,\"button\"],[4,[38,5],[\"click\",[30,0,[\"toggleDrawer\"]]],null],[12],[1,\"\\n          \"],[10,1],[14,0,\"tAC--mmaAddModal__drawerTitle\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"account.groups.group.meta_ad_accounts.add_modal.added_accounts_header\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"],[41,[30,0,[\"drawerOpen\"]],[[[1,\"            \"],[1,[28,[35,7],[\"caret-up\"],[[\"class\"],[\"tAC--mmaAddModal__drawerCaret\"]]]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,7],[\"caret-down\"],[[\"class\"],[\"tAC--mmaAddModal__drawerCaret\"]]]],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n\"],[41,[30,0,[\"drawerOpen\"]],[[[1,\"          \"],[10,\"ul\"],[14,0,\"tAC--mmaAddModal__drawerBody qa--mmaAddModal__drawerBody\"],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"addedAccounts\"]]],null]],null],null,[[[1,\"              \"],[10,\"li\"],[14,0,\"tAC--mmaAddModal__addedRow tAC--mmaAddModal__addedRow--dimmed qa--mmaAddModal__addedRow\"],[15,\"data-ad-account-id\",[30,7,[\"id\"]]],[12],[1,\"\\n                \"],[10,0],[14,0,\"tAC--mmaAddModal__rowCheck\"],[12],[1,\"\\n                  \"],[10,1],[14,0,\"tAC--mmaAddModal__checkIcon tAC--mmaAddModal__checkIcon--on\"],[12],[1,\"\\n                    \"],[1,[28,[35,7],[\"check\"],[[\"class\"],[\"tAC--mmaAddModal__checkGlyph\"]]]],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,0],[14,0,\"tAC--mmaAddModal__rowBody\"],[12],[1,\"\\n                  \"],[10,1],[14,0,\"tAC--mmaAddModal__rowName\"],[12],[1,[30,7,[\"name\"]]],[13],[1,\"\\n                  \"],[10,0],[14,0,\"tAC--mmaAddModal__rowSubtitle\"],[12],[1,\"\\n\"],[41,[30,7,[\"businessPortfolioName\"]],[[[1,\"                      \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.row.subtitle_with_portfolio\"],[[\"businessPortfolioName\",\"uid\"],[[30,7,[\"businessPortfolioName\"]],[30,7,[\"uid\"]]]]]],[1,\"\\n\"]],[]],[[[1,\"                      \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.row.subtitle_id_only\"],[[\"uid\"],[[30,7,[\"uid\"]]]]]],[1,\"\\n\"]],[]]],[1,\"                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[7]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],[[24,0,\"tAC--mmaAddModal__footer\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,10],[[24,0,\"tAC--mmaAddModal__saveBtn qa--mmaAddModal__saveBtn\"]],[[\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"cantSave\"]],[30,0,[\"save\"]],[28,[37,1],[\"account.groups.group.meta_ad_accounts.add_modal.add_button\"],[[\"count\"],[[30,0,[\"selectedCount\"]]]]],\"primary\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@onClose\",\"modal\",\"@group\",\"adAccount\",\"badge\",\"badge\",\"adAccount\"],false,[\"shared/modal\",\"t\",\"if\",\"each\",\"-track-array\",\"on\",\"fn\",\"svg-jar\",\"let\",\"concat\",\"shared/ui/button\"]]",
    "moduleName": "settings/components/meta-ad-accounts-card/group-ad-accounts-tab/add-modal/index.hbs",
    "isStrictMode": false
  });
  let AddModalComponent = _exports.default = (_class = class AddModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "metaMarketingApiAuth", _descriptor4, this);
      _initializerDefineProperty(this, "store", _descriptor5, this);
      _initializerDefineProperty(this, "availableAccounts", _descriptor6, this);
      _initializerDefineProperty(this, "saving", _descriptor7, this);
      // eslint-disable-next-line unicorn/no-null
      _initializerDefineProperty(this, "bannerError", _descriptor8, this);
      _initializerDefineProperty(this, "drawerOpen", _descriptor9, this);
      _defineProperty(this, "selectedIds", new _trackedBuiltIns.TrackedSet());
      _defineProperty(this, "isSelected", id => this.selectedIds.has(id));
      _defineProperty(this, "statusBadgeFor", adAccount => (0, _metaAdAccountStatus.getStatusBadge)(adAccount.accountStatusLabel));
      this.loadAvailable();
    }
    async loadAvailable() {
      const records = await this.store.findAll('meta-ad-account', {
        reload: true
      });
      const groupId = this.args.group.id;
      this.availableAccounts = records.toArray().filter(acc => {
        if (acc.disconnectedTime) return false;
        const groups = (0, _toArray.default)(acc.groups);
        return !groups.some(g => g.id === groupId);
      });
    }
    get availableById() {
      return new Map(this.availableAccounts.map(a => [a.id, a]));
    }
    get addedAccounts() {
      return (0, _toArray.default)(this.args.group.metaAdAccounts).filter(a => !a.disconnectedTime);
    }
    get selectedCount() {
      return this.selectedIds.size;
    }
    get canSave() {
      return this.selectedCount > 0 && !this.saving;
    }
    get cantSave() {
      return !this.canSave;
    }
    toggleSelect(id) {
      if (this.selectedIds.has(id)) this.selectedIds.delete(id);else this.selectedIds.add(id);
    }
    toggleDrawer() {
      this.drawerOpen = !this.drawerOpen;
    }
    async save() {
      const groupId = this.args.group.id;
      const assignments = [...this.selectedIds].map(adAccountId => {
        const acc = this.availableById.get(adAccountId);
        const existingIds = (0, _toArray.default)(acc.groups).map(g => g.id);
        return {
          meta_ad_account_id: adAccountId,
          group_ids: [...new Set([...existingIds, groupId])]
        };
      });
      this.saving = true;
      // eslint-disable-next-line unicorn/no-null
      this.bannerError = null;
      try {
        const response = await this.metaMarketingApiAuth.bulkSetGroups(assignments);
        if (response.failed.length === 0) {
          await this.store.findRecord('group', groupId, {
            reload: true
          });
          this.alerts.success(this.intl.t('account.groups.group.meta_ad_accounts.add_modal.success', {
            count: assignments.length
          }));
          this.args.onClose();
          return;
        }

        // Partial: drop succeeded ids so user can't double-add, reload group so the
        // underlying tab table reflects the partial wins, surface a banner with
        // the failed count + first error message.
        for (const s of response.succeeded) this.selectedIds.delete(s.meta_ad_account_id);
        await this.store.findRecord('group', groupId, {
          reload: true
        });
        this.bannerError = this.intl.t('account.groups.group.meta_ad_accounts.add_modal.partial_error', {
          failed: response.failed.length,
          message: response.failed[0]?.errors[0] ?? ''
        });
      } catch (e) {
        this.bannerError = this.intl.t('account.groups.group.meta_ad_accounts.add_modal.error');
        this.errors.log(e);
      } finally {
        this.saving = false;
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "metaMarketingApiAuth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "availableAccounts", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "saving", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "bannerError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "drawerOpen", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleSelect", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleDrawer", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleDrawer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AddModalComponent);
});